import { colors, fonts, pxToCssFont } from '@vfit/shared/themes';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AboveLabel = styled.span`
  font-family: ${fonts.vodafone};
  font-weight: 800;
  ${pxToCssFont(16, 22)};
  color: ${colors.$e60000};
  text-align: center;
`;
